import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index.tsx";
import ScrollToTop from "./components/ScrollToTop";

const ProjectDetail = lazy(() => import("./pages/ProjectDetail.tsx"));
const NieSpimCaseStudy = lazy(() => import("./pages/NieSpimCaseStudy.tsx"));
const FispreadCaseStudy = lazy(() => import("./pages/FispreadCaseStudy.tsx"));
const SeedHouseSadovoCaseStudy = lazy(() => import("./pages/SeedHouseSadovoCaseStudy.tsx"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy.tsx"));
const TermsOfUse = lazy(() => import("./pages/TermsOfUse.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const ShsadovoIdimperialAgreva = lazy(() => import("./pages/offers/ShsadovoIdimperialAgreva.tsx"));
const EleenGardens = lazy(() => import("./pages/offers/EleenGardens.tsx"));
const EleenGardensWebsite = lazy(() => import("./pages/offers/EleenGardensWebsite.tsx"));
const SksIdImperialMarketing = lazy(() => import("./pages/offers/SksIdImperialMarketing.tsx"));
const IdImperialCrmEmailMarketing = lazy(() => import("./pages/offers/IdImperialCrmEmailMarketing.tsx"));
const ShsadovoMarketing = lazy(() => import("./pages/offers/ShsadovoMarketing.tsx"));
const OneOhOneCarat = lazy(() => import("./pages/offers/OneOhOneCarat.tsx"));
const Nt3Consult = lazy(() => import("./pages/offers/Nt3Consult.tsx"));

const App = () => (
  <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/work/nie-spim" element={<NieSpimCaseStudy />} />
          <Route path="/work/fispread" element={<FispreadCaseStudy />} />
          <Route path="/work/seed-house-sadovo" element={<SeedHouseSadovoCaseStudy />} />
          <Route path="/work/:slug" element={<ProjectDetail />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/offers/shsadovo-idimperial-agreva" element={<ShsadovoIdimperialAgreva />} />
          <Route path="/offers/eleengardens" element={<EleenGardens />} />
          <Route path="/offers/eleen-gardens" element={<EleenGardensWebsite />} />
          <Route path="/offers/sks-idimperial-marketing" element={<SksIdImperialMarketing />} />
          <Route path="/offers/idimperial-crm-email-marketing" element={<IdImperialCrmEmailMarketing />} />
          <Route path="/offers/shsadovo-marketing" element={<ShsadovoMarketing />} />
          <Route path="/offers/101carat" element={<OneOhOneCarat />} />
          <Route path="/offers/nt3-consult" element={<Nt3Consult />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);

export default App;